module.exports = __webpack_public_path__ + "img/index-img.d6faf8ae.png";